import { useCallback } from "react";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import { CrossIcon } from "@/shared/icons";
import { setChatOpen } from "@/domains/chat/slice";
import ChatControlButton from "@/domains/chat/components/chat/controls/ChatControlButton";

export default function ChatCloseButtonContainer() {
  const dispatch = useAppDispatch();

  const onClickHandler = useCallback(() => dispatch(setChatOpen(false)), [dispatch]);

  return (
    <ChatControlButton onClick={onClickHandler}>
      <CrossIcon size={16} className="text-white/60 group-hover:text-white transition" />
    </ChatControlButton>
  );
}
